import type { WallSidePathDomain, WallSideVerticalDomain } from "building-types/walls/wallSideTypes";
import type { LevelInches } from "common/types/nominalNumbersTypes";

export function wallSidePathDomainNew(startT: number, endT: number): WallSidePathDomain {
  return {
    startT,
    endT,
  };
}

export function wallSideVerticalDomainNew(top: LevelInches, bottom: LevelInches): WallSideVerticalDomain {
  return {
    top,
    bottom,
  };
}
